import { Spin } from "antd";
import { ReactNode, Suspense as ReactSuspense } from "react";
import { twMerge } from "tailwind-merge";

export function Loader({ className }: { className?: string }) {
  return (
    <div
      className={twMerge("flex justify-center items-center py-8", className)}
    >
      <Spin />
    </div>
  );
}

export function Suspense({
  children,
  fallback,
}: {
  children: ReactNode;
  fallback?: ReactNode;
}) {
  return (
    <ReactSuspense fallback={fallback ?? <Loader />}>{children}</ReactSuspense>
  );
}

export function WithSuspense<T extends object>(
  Component: (props: T) => ReactNode,
  fallback?: ReactNode,
) {
  function ComponentWithSuspense(props: T) {
    return (
      <Suspense fallback={fallback}>
        <Component {...props} />
      </Suspense>
    );
  }

  return ComponentWithSuspense;
}
